import PropTypes from 'prop-types'
import { Box, FormControl, FormLabel, Grid, GridItem, Heading, Select } from '@chakra-ui/react'

export const SOFTWARE_OPTIONS = {
  Cloud: 'Cloud Software',
  PC: 'PC Software'
}

export const EdgeSoftwareForm = ({ form, setForm, ...rest }) => {
  return (
    <Box {...rest}>
      <Grid
        templateColumns="5fr 1fr"
        rowGap={5}
        columnGap={10}
        w="900px"
        maxW="100%"
      >
        <GridItem>
          <Heading size="md">Software</Heading>
        </GridItem>
        <GridItem></GridItem>
        <GridItem>
          <FormControl isRequired>
            <FormLabel>Software</FormLabel>
            <Select
              value={form.software}
              onChange={e => setForm(draft => { draft.software = e.target.value })}
              placeholder="Select"
            >
              <option value={SOFTWARE_OPTIONS.Cloud}>{SOFTWARE_OPTIONS.Cloud}</option>
              <option value={SOFTWARE_OPTIONS.PC}>{SOFTWARE_OPTIONS.PC}</option>
            </Select>
          </FormControl>
        </GridItem>
      </Grid>
    </Box>
  )
}

EdgeSoftwareForm.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func
}
